<template>
  <main-layout class="mainbody">
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-04"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("button.system.building.detail.destinationSetting") }}</label>
        <narrow-down @click="showConfirm" slot="create">{{
          $t("button.common.data.create")
        }}</narrow-down>
        <sp-smart-button @click="clickCancel" slot="cancel">{{
          $t("button.common.cancel")
        }}</sp-smart-button>
      </head-title>
    </el-row>

    <!--  body start  -->
    <div slot="body">
      <!-- subtitle -->

      <!--  form start  -->
      <el-form
        :model="linkInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="202px"
        label-position="left"
      >
        <el-row>
          <el-col :span="24">
            <div class="main-title margin-bottom-0 margin-top-56">
              事業者情報
            </div>
            <hr class="hr-delimiter" />

            <!-- 適格請求書発行事業名称 -->
            <el-form-item
              size="small"
              class="master-start input-margin-top line-height-44"
              prop="businessName"
              label="適格請求書発行事業名称"
            >
              <el-input
                class="main-input show-word-limt-input-iot"
                maxlength="50"
                show-word-limit
                v-model="linkInfo.businessName"
                :placeholder="$t('label.taxTemplate.businessNumber')">
              </el-input>
            </el-form-item>

            <!-- 登録番号 -->
            <el-form-item
              size="small"
              class="master-start input-margin-top line-height-44"
              prop="businessNumber"
              label="登録番号"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="14"
                show-word-limit
                v-model="linkInfo.businessNumber"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.businessNumber')
                "
              >
              </el-input>
            </el-form-item>

            <!-- 特定商取引法について -->
            <el-form-item
              size="small"
              class="master-start input-margin-top line-height-44"
              prop="specificTransactionUrl"
              label="特定商取引法について"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="256"
                v-model="linkInfo.specificTransactionUrl"
                :placeholder="$t('label.destinationSetting.APIConnectionInfo.specificTransactionUrl')"
              >
              </el-input>
            </el-form-item>
            <!-- リンク型接続先情報 -->
            <div class="main-title margin-bottom-0 margin-top-56">
              {{ $t('label.destinationSetting.LinkedConnection.title') }}
            </div>
            <hr class="hr-delimiter" />
            <!-- 購入要求接続先 -->
            <el-form-item
              size="small"
              class="line-height-44"
              prop="purchaseLinkUrl"
              :label="$t('label.destinationSetting.LinkedConnection.PurchaseRequest')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.purchaseLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.PurchaseRequest')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 顧客登録要求接続先 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="customerLoginLinkUrl"
              :label="$t('label.destinationSetting.LinkedConnection.CustomerRequest')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.customerLoginLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.CustomerRequest')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 定期申込要求連絡先 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="regularApplyLinkUrl"
              :label="$t('label.destinationSetting.LinkedConnection.RegularApplicationContact')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.regularApplyLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.RegularApplicationContact')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 通信元IPアドレス -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44 hint-input"
              prop="linkOrgAddress"
              :label="$t('label.destinationSetting.LinkedConnection.SourceIP')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.linkOrgAddress"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.SourceIP')
                "
              >
              </el-input>
            </el-form-item>
            <!-- <label class="hint">IP制限をかけている場合は許可願います</label> -->
              <!-- ハッシュキー -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="linkHashKey"
              :label="$t('label.destinationSetting.LinkedConnection.HashKey')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.linkHashKey"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.HashKey')
                "
              >
              </el-input>
            </el-form-item>
            <!-- linkマーチャントID -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="linkMerchantId"
              :label="$t('label.destinationSetting.LinkedConnection.merchantId')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.linkMerchantId"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.merchantId')
                "
              >
              </el-input>
            </el-form-item>
            <!-- linkサービスID -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="linkServiceId"
              :label="$t('label.destinationSetting.LinkedConnection.ServiceId')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.linkServiceId"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.ServiceId')
                "
              >
              </el-input>
            </el-form-item>

            <div class="main-title margin-bottom-0 margin-top-56">
              {{ $t('label.destinationSetting.APIConnectionInfo.title') }}
            </div>
            <hr class="hr-delimiter" />

            <!-- 各種API接続先 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="apiLinkUrl"
              :label="$t('label.destinationSetting.APIConnectionInfo.APIEndpointVariety')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.apiLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.APIEndpointVariety')
                "
              >
              </el-input>
            </el-form-item>
            <!-- トークンサービス接続先 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="tokenServiceLinkUrl"
              :label="$t('label.destinationSetting.APIConnectionInfo.TokenServiceEndpoint')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.tokenServiceLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.TokenServiceEndpoint')
                "
              >
              </el-input>
            </el-form-item>
            <!-- EMV 3-D セキュアカード利用者トークン接続先 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-22"
              prop="emvSecurityLinkUrl"
              :label="$t('label.destinationSetting.APIConnectionInfo.SecureCardUserTokenEndpoint')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.emvSecurityLinkUrl"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.SecureCardUserTokenEndpoint')
                "
              >
              </el-input>
            </el-form-item>
            <!-- ハッシュキー -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="apiHashKey"
              :label="$t('label.destinationSetting.APIConnectionInfo.HashKey')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.apiHashKey"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.HashKey')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 3DES 暗号化キー -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="encryptKey"
              :label="$t('label.destinationSetting.APIConnectionInfo.EncryptionKey')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.encryptKey"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.EncryptionKey')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 3DES 初期化キー -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="initKey"
              :label="$t('label.destinationSetting.APIConnectionInfo.InitializationKey')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.initKey"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.InitializationKey')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 3DES padding 設定 -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="padding"
              :label="$t('label.destinationSetting.APIConnectionInfo.paddingSetting')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.padding"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.paddingSetting')
                "
              >
              </el-input>
            </el-form-item>
            <!-- <label class="hint">自動Paddingなしのため、最後の8バイトブロックに対し補完文字列が必要となります。（半角スペース）</label> -->
            <!-- Basic 認証 ID -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="basicAuthId"
              :label="$t('label.destinationSetting.APIConnectionInfo.AuthenticationID')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.basicAuthId"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.AuthenticationID')
                "
              >
              </el-input>
            </el-form-item>
            <!-- Basic 認証 Password -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="basicAuthPassword"
              :label="$t('label.destinationSetting.APIConnectionInfo.AuthenticationPassword')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.basicAuthPassword"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.AuthenticationPassword')
                "
              >
              </el-input>
            </el-form-item>
            <!-- apiマーチャントID -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="apiMerchantId"
              :label="$t('label.destinationSetting.LinkedConnection.merchantId')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.apiMerchantId"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.merchantId')
                "
              >
              </el-input>
            </el-form-item>
            <!-- apiサービスID -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="apiServiceId"
              :label="$t('label.destinationSetting.LinkedConnection.ServiceId')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.apiServiceId"
                :placeholder="
                  $t('label.destinationSetting.LinkedConnection.ServiceId')
                "
              >
              </el-input>
            </el-form-item>
            <!-- 通信元IPアドレス -->
            <el-form-item
              size="small"
              class="input-margin-top line-height-44"
              prop="apiOrgAddress"
              :label="$t('label.destinationSetting.APIConnectionInfo.SourceIPAddress')"
            >
              <el-input
                type="text"
                class="main-input show-word-limt-input-iot"
                maxlength="100"
                v-model="linkInfo.apiOrgAddress"
                :placeholder="
                  $t('label.destinationSetting.APIConnectionInfo.SourceIPAddress')
                "
              >
              </el-input>
            </el-form-item>
            <!-- <label class="hint">IP制限をかけている場合は許可願います。</label> -->


          </el-col>
        </el-row>
      </el-form>
      <loading-dialog :dialogVisible="showLoading" />

      <dialog-confirm
        :clickFlag="false"
        :visible.sync="isDialogConfirmComplete"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        :cancelFlag="cancelFlag"
        :colorFlag="true"
        @on-confirm="snsConfirm"/>

    </div>
    <!--  body end  -->
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import creditDestination from "@/rules/rule-credit-destination";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm";

export default {
  name: "MeetingRoomCreate",
  components: {
    MainLayout: MainLayout,
    LoadingDialog: LoadingDialog,
    headTitle: headTitle,
    narrowDown: narrowDown,
    SpSmartButton: SpSmartButton,
    Menubar: Menubar,
    DialogConfirm: DialogConfirm
  },
  data() {
    return {
      orgId: null,
      isDialogConfirmComplete: false,
      cancelFlag: true,
      dialogComplete: {
        title:'',
        content:''
      },
      intention: 'confirm',
      linkInfo: {
        businessName: null,
        businessNumber: null,
        specificTransactionUrl: null,
        purchaseLinkUrl: null,
        customerLoginLinkUrl: null,
        regularApplyLinkUrl: null,
        linkOrgAddress: null,
        linkHashKey: null,
        linkMerchantId: null,
        linkServiceId: null,
        apiLinkUrl: null,
        tokenServiceLinkUrl: null,
        emvSecurityLinkUrl: null,
        apiHashKey: null,
        encryptKey: null,
        initKey: null,
        padding: null,
        basicAuthId: null,
        basicAuthPassword: null,
        apiOrgAddress: null,
        apiMerchantId:null,
        apiServiceId:null,
      },
      showLoading: false,
      rules: creditDestination.createRules(this),

    };
  },
  methods: {

    getPointCreditCardPayment() {
      this.showLoading = true
      SystemManageApi.PointCreditCardPaymentGet(this.orgId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          if(data !== null) {
            this.linkInfo.businessName = data.body?.businessInfo.businessName
            this.linkInfo.businessNumber = data.body?.businessInfo.businessNumber
            this.linkInfo.specificTransactionUrl = data.body?.businessInfo.specificTransactionUrl

            this.linkInfo.purchaseLinkUrl = data.body.linkConnectionInfo.purchaseLinkUrl
            this.linkInfo.customerLoginLinkUrl = data.body.linkConnectionInfo.customerLoginLinkUrl
            this.linkInfo.regularApplyLinkUrl = data.body.linkConnectionInfo.regularApplyLinkUrl
            this.linkInfo.linkOrgAddress = data.body.linkConnectionInfo.orgAddress
            this.linkInfo.linkHashKey = data.body.linkConnectionInfo.hashKey
            this.linkInfo.linkMerchantId = data.body.linkConnectionInfo.merchantId
            this.linkInfo.linkServiceId = data.body.linkConnectionInfo.serviceId

            this.linkInfo.apiLinkUrl = data.body.apiConnectionInfo.apiLinkUrl
            this.linkInfo.tokenServiceLinkUrl = data.body.apiConnectionInfo.tokenServiceLinkUrl
            this.linkInfo.emvSecurityLinkUrl = data.body.apiConnectionInfo.emvSecurityLinkUrl
            this.linkInfo.apiHashKey = data.body.apiConnectionInfo.hashKey
            this.linkInfo.encryptKey = data.body.apiConnectionInfo.encryptKey3Des
            this.linkInfo.initKey = data.body.apiConnectionInfo.initKey3Des
            this.linkInfo.padding = data.body.apiConnectionInfo.padding3Des
            this.linkInfo.basicAuthId = data.body.apiConnectionInfo.basicAuthId
            this.linkInfo.basicAuthPassword = data.body.apiConnectionInfo.basicAuthPassword
            this.linkInfo.apiOrgAddress = data.body.apiConnectionInfo.orgAddress
            this.linkInfo.apiMerchantId = data.body.apiConnectionInfo.merchantId
            this.linkInfo.apiServiceId = data.body.apiConnectionInfo.serviceId
          }
        })
        .finally(() => {
          this.showLoading = false
        })
    },
    //キャンセル
    clickCancel () {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      });
    },
    snsConfirm(){
      if(this.intention == "confirm") {
        this.UpdatePointPaymentConnection()
      }
    },
    showConfirm() {
      this.intention = "confirm"
      this.dialogComplete = {
        title:'登録確認',
        content:'この内容で登録しますか？'
      }
      this.cancelFlag = true
      this.isDialogConfirmComplete = true
    },
    UpdatePointPaymentConnection() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.showLoading = true
          let updateInfo = {
            businessInfo: {
              businessName: this.linkInfo.businessName,
              businessNumber: this.linkInfo.businessNumber,
              specificTransactionUrl: this.linkInfo.specificTransactionUrl
            },

            linkConnectionInfo: {
              purchaseLinkUrl: this.linkInfo.purchaseLinkUrl,
              customerLoginLinkUrl: this.linkInfo.customerLoginLinkUrl,
              regularApplyLinkUrl: this.linkInfo.regularApplyLinkUrl,
              orgAddress: this.linkInfo.linkOrgAddress,
              hashKey: this.linkInfo.linkHashKey,
              merchantId: this.linkInfo.linkMerchantId,
              serviceId: this.linkInfo.linkServiceId,

            },
            apiConnectionInfo: {
              apiLinkUrl: this.linkInfo.apiLinkUrl,
              tokenServiceLinkUrl: this.linkInfo.tokenServiceLinkUrl,
              emvSecurityLinkUrl: this.linkInfo.emvSecurityLinkUrl,
              hashKey: this.linkInfo.apiHashKey,
              encryptKey3Des: this.linkInfo.encryptKey,
              initKey3Des: this.linkInfo.initKey,
              padding3Des: this.linkInfo.padding,
              basicAuthId: this.linkInfo.basicAuthId,
              basicAuthPassword: this.linkInfo.basicAuthPassword,
              orgAddress: this.linkInfo.apiOrgAddress,
              merchantId: this.linkInfo.apiMerchantId,
              serviceId: this.linkInfo.apiServiceId,
            }

          }
          SystemManageApi.PointCreditCardPaymentUpdate(this.orgId, updateInfo)
            .then(({ data }) => {
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                return
              }
              this.showLoading = false
              // this.$messageIotSuccess(this.$t("message.common.save"))
              this.intention = "back"
              this.dialogComplete = {
                title:'登録完了',
                content:'クレジット接続先設定を登録しました'
              }
              this.cancelFlag = false
              this.isDialogConfirmComplete = true
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .finally(() => {
              this.showLoading = false

            })
        }
      })
    },

  },
  mounted() {
    this.getPointCreditCardPayment()
  },
  created() {
    // this.$authCheck("010317");
    let breadcrumb = [
    {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerBreadDeatil",
      },
      {
        path: "",
        title: "label.router.destinationSetting",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.orgId = this.$route.query.orgId
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)

  },
};
</script>

<style lang="scss" scoped>
.hint{
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: left;
  margin-left: 202px;
  position: relative;
  top: 13px;
}
::v-deep.hint-input > .el-form-item__content{
  .el-form-item--small .el-form-item__error{
    margin-top: 22px!important;
  }
}
.input-margin-top{
  margin-top: 24px;
}

::v-deep .el-form-item__label {
  color: #525250 !important;
  font-size: 16px;
  height: 44px;
  line-height: 44px;
}
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 0px !important;
}
::v-deep .el-icon-arrow-up:before {
  color: #525250;
}

.el-form-item--small .el-form-item__content {
  line-height: 44px;
}

::v-deep .cancel-width {
  .my-button {
    width: 152px;
    height: 32px;
  }
}

::v-deep .main-input {
  .el-input__inner {
    width: 511px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep .el-input__inner {
  border: none;
  background: #f2f2ed;
  color: #525250;
  font-size: 15px !important;
}


::v-deep .img-list .img-li-box .img-li-b--url {
  background-color: #F7F7F2;
  object-fit: scale-down;
  max-width: 500px;
  width: auto;
}
.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
.line-height-22::v-deep {
  .el-form-item__label {
    line-height: 22px !important;
  }
}
.show-word-limt-input-iot {
  width: 511px !important;
}

.hr-delimiter {
  margin-top: 16px;
  margin-bottom: 40px;
  background-color: #d1d1cd !important;
}

.businessName {
  width: 511px;
  ::v-deep.el-textarea__inner {
    width: 511px!important;
    height: 68px;
  }
  ::v-deep.el-input__count {
    background-color: transparent;
  }
}

::v-deep .master-start > .el-form-item__label::after {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.margin-top-56{
  margin-top: 56px !important;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #525250;
}
</style>
